import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocationService } from '@app/core/services/location.service';

export const locationSetGuard: CanActivateFn = (): boolean => {
  const locationService = inject(LocationService);
  const router = inject(Router);
  if (locationService.currentLocation != null) {
    return true;
  }

  router.navigateByUrl('/');
  return false;
};
